(function () {
  function remainingUntilMidnight() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);

    var remaining = Math.max(0, midnight.getTime() - now.getTime());
    var hours = Math.floor(remaining / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    return [hours, minutes, seconds]
      .map(function (value) {
        return String(value).padStart(2, "0");
      })
      .join(":");
  }

  function initCountdown(root) {
    var output = root.querySelector("[data-frl-countdown]");
    if (!output || output.dataset.initialized === "true") return;

    output.dataset.initialized = "true";

    function update() {
      output.textContent = remainingUntilMidnight();
    }

    update();
    window.setInterval(update, 1000);
  }

  function initSmoothLinks(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.frlSmooth === "true") return;
      link.dataset.frlSmooth = "true";

      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href");
        if (!id || id === "#") return;

        var target = document.querySelector(id);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function initListicle(root) {
    if (!root || root.dataset.frlInitialized === "true") return;
    root.dataset.frlInitialized = "true";
    initCountdown(root);
    initSmoothLinks(root);
  }

  function initAll() {
    document.querySelectorAll(".frl").forEach(initListicle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(".frl");
    if (root) initListicle(root);
  });
})();
